import type { Theme } from "../theme";

import * as React from "react";

type Props = {
  children: React.ReactNode;
  onClick?: () => void;
};

const Icon = (props: Props): React.ReactNode => (
  <button
    onClick={props.onClick}
    css={({ iconSize, gridUnit, colors }: Theme) => ({
      padding: gridUnit,
      display: "inline-block",
      borderRadius: `${gridUnit}px ${gridUnit}px 0 0`,
      svg: {
        width: iconSize,
        height: iconSize,
        fill: colors.grey2
      },
      div: {
        fontSize: gridUnit * 3,
        color: colors.grey4,
        textAlign: "center"
      }
    })}
  >
    {props.children}
  </button>
);

export default Icon;
